import { apiPlugin, storyblokInit } from "@storyblok/react/rsc";
import { COMPONENTS } from "@/constants/sbComponents";
import { Fallback } from "@/components/Fallback";

// Exported separately from api.ts so that client components (StoryblokProvider)
// can import just this without pulling in server-only modules (redis, cv-store).
export const getStoryblokApi = storyblokInit({
  accessToken: process.env.NEXT_PUBLIC_STORYBLOK_TOKEN,
  use: [apiPlugin],
  components: COMPONENTS,
  enableFallbackComponent: true,
  customFallbackComponent: Fallback,
  // Disable Storyblok's internal memory cache so every getStory() call goes through
  // native fetch(), which Next.js intercepts and caches with next.tags.
  // Without this, revalidateTag("sb-cache-version") has no effect because
  // Storyblok returns data from its own memory without ever calling fetch().
  apiOptions: { region: "us", cache: { clear: "auto", type: "none" } },
});
